export default "__VITE_ASSET__C3yx6b$W__"